/* unplugin-vue-components disabled */import { render } from "./Spin.vue?vue&type=template&id=3b9d62ba&scoped=true&ts=true"
import script from "./Spin.vue?vue&type=script&lang=ts"
export * from "./Spin.vue?vue&type=script&lang=ts"

import "./Spin.vue?vue&type=style&index=0&id=3b9d62ba&lang=scss&scoped=true"

import exportComponent from "/var/static/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9d62ba"]])

export default __exports__